/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import "./App.css";
import { useLogin } from "./auth/hooks/useLogin";
import { changeYupLocale } from "./helper/Yup";
import i18n from "./i18n";
import ThemeLayout from "./theme/layout/ThemeLayout";

function App() {
  const { getAccountInfo } = useLogin();
  useEffect(() => {
    getAccountInfo();
    i18n.on("initialized", (option) => {
      changeYupLocale();
    });
  }, []);

  return (
    <>
      <ThemeLayout />
    </>
  );
}

export default withTranslation()(App);
